import { useEffect, useState } from 'react';
import DatePicker from './components/DatePicker/DatePicker';
import DropdownContainer from './components/DropDownMenu/DropDownContainer';
import CheckBoxContainer from './components/CheckBox/CheckBoxContainer';
import RadioBoxContainer from './components/RadioBox/RadioBoxContainer';
import ZipCodeContainer from './components/ZipCodeContainer/ZipCodeContainer';
import NodeCheckBoxContainer from './components/NodeCheckBox/NodeCheckBoxContainer';
import RangePicker from './components/RangePicker/RangePicker';
import InputContainer from './components/Input/InputContainer';
import { useDispatch, useSelector } from 'react-redux';
import {
  updateChoiceMetadata,
  updateQuestionValue,
} from '../../../redux/actions/questionnaireActions';
import {
  choicesToRender,
  deepClone,
  evalCondition,
  evaluateCondition,
  filterAndDispatch,
  findNextQuestion,
  findQuestionValue,
  parseConditionalValue,
  sanitiseHTML,
  shouldRenderChoice,
  splitMultipleConditions,
  stringToObject,
} from '../../../legacy/utils/helpers';
import { setUserFullName } from '../../../redux/modules/authentication';
import CardComponentContainer from './components/CardComponent/CardComponentContainer';
import TextArea from './components/TextArea/TextArea';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import './questionOptionsLibrary.scss';

import IntakeCompletionWelcomeContainer from '../../IntakeCompletionWelcomeScreen/IntakeCompletionWelcomeContainer';
import RadioCardComponentContainer from './components/CardComponent/RadioCardComponentContainer';
import {
  clearModalContent,
  setModalContent,
} from '../../../redux/modules/modalEvent';
import { togglePopupLoader } from '../../../redux/actions/configurationActions';
import Payment from './components/Payment/Payment';
import ClinicianAvailabilityQuestion from './components/ClinicianAvailability/CliniaianAvailability.question';
import { Typography } from 'src/latest/src/components';
import { Logger } from 'src/latest/src/services';
import { useIsMobile } from 'src/latest/src/hooks';
import { TypeAheadLocationSearch } from 'src/latest/src';
import {
  ConsentForm,
  SignPad,
} from 'src/latest/src/containers/QuestionnaireParent/components';
import { setUserToBeOnboarded } from 'src/redux/actions/onboardingActions';
import DocumentUpload from 'src/latest/src/components/TherapisDocumentUpload/DocumentUpload';
import { DocumentType } from 'src/latest/src/constants/DocumentTypeEnum';
import { PhotoInformationContainer } from 'src/latest/src/components/Photo/PhotoInformationContainer';
import { get } from 'lodash';
import { noop } from 'react-bootstrap-typeahead/types/utils';
import UploadDocument from 'src/latest/src/containers/QuestionnaireParent/components/UploadDocument/UploadDocument';
import { QuestionsUniqueKeys } from 'src/containers/QuestionnaireParent/QuestionnaireEnum';
import { AddCardStatus } from 'src/latest/src/constants/AddCardStatus';
import StripePayment from './components/StripePayment/StripePayment';
import PaymentExplanationPage from 'src/latest/src/components/PaymentExplanation/PaymentExplanationPage';
import { QuestionType } from 'src/latest/src/constants/QuestionType';
import MiniCheckBox from './components/MiniCheckBox/MiniCheckBox';
import ProviderBenefitPage from '../QuestionnairePages/ProviderBenefitPage/ProviderBenefitPage';
import PracticeSummaryInfoPage from '../../../latest/src/containers/QuestionnaireParent/components/PracticeSummaryInfoPage/PracticeSummaryInfoPage';
import PasswordScreenClientQuestionnaire from 'src/latest/src/features/magic-link/PasswordScreenClientQuestionnaire';

type Props = {
  question: object,
  setUploading: any,
  isFileTypeInvalid: Boolean,
  setIsFileTypeInvalid: any,
  handleOnclick: Function,
  setIsMatchAssistance?: (isMatchAssistance: boolean) => void,
  onStripeCardStatusChange?: (hasCard: boolean) => void,
  onStripeCardFormValidationChange?: (isValid: boolean) => void,
  stripePaymentRef?: any,
  onStripeProcessingChange?: (isProcessing: boolean) => void,
};

function QuestionOptionsLibrary({
  question,
  setUploading,
  isFileTypeInvalid,
  setIsFileTypeInvalid,
  handleOnclick,
  setIsMatchAssistance = noop,
  onStripeCardStatusChange,
  onStripeCardFormValidationChange,
  stripePaymentRef,
  onStripeProcessingChange,
}: Props): React$Element<any> {
  const type = question?.metadata?.question_type;
  const documentType = question?.metadata?.doc_type;
  const supportData = question?.metadata?.support_data;
  const fileMaxSize = question?.metadata?.file_max_size;
  const infoMessage = question.info_message;
  const isRequired = question.required;
  const metaData = question.metadata;
  const currentQuestions = useSelector(
    state => state?.questionnaireData?.currentConfig?.currentQuestions,
  );
  const currentPage = useSelector(
    state => state?.questionnaireData?.currentConfig?.currentPage,
  );
  const isDirectoryPlatform = useSelector(
    state => state.configuration?.isDirectoryPlatform === 'true',
  );
  const choices = choicesToRender(
    deepClone(question.choices),
    currentQuestions,
  );
  const loggedInSelfUser = useSelector(
    state => state?.authentication?.loggedInUser,
  );
  const selfQuestionnaireUserId = useSelector(
    state => state?.questionnaireData?.initialMetadata?.user_id,
  );
  const selfUserId = selfQuestionnaireUserId || loggedInSelfUser?.id;
  const userToBeOnboarded = useSelector(state =>
    state?.onboarding?.userToBeOnboarded?.id?.length > 0
      ? state?.onboarding?.userToBeOnboarded
      : state?.questionnaireData?.clientMetaData,
  );
  const isFromMobile = useIsMobile();
  const ignoredUniqueKeys = [
    'additionalParticipantFirstNameQuestion1',
    'additionalParticipantLastNameQuestion1',
    'policyholderfirstnameinsurancedetailsquestion',
    'policyholderlastnameinsurancedetailsquestion',
  ];
  const dispatch = useDispatch();
  // This is static data to check the multiple instances of slider can be removed later
  // const answered = [];

  // const [inputValue, setInputValue] = useState(null);

  // eslint-disable-next-line no-unused-vars
  const poulateFromSource = async (value: any) => {
    if (currentPage.metadata) {
      const metadata = stringToObject(currentPage.metadata);

      // execution will come here if only meet this condition
      if (metadata.trigger && metadata.default_populate && metadata.map) {
        const questions = deepClone(currentQuestions);
        const parsedCondition = evalCondition(metadata.trigger);

        const currentQuestionIndex = questions.findIndex(
          q =>
            q.unique_key === parseConditionalValue(parsedCondition.leftValue),
        );

        let currentQuestion = questions[currentQuestionIndex] || {};

        currentQuestion = { ...currentQuestion, ...{ choices: value } };

        if (currentQuestion.id === question.id) {
          const questionValue = findQuestionValue(currentQuestion);

          const shouldTrigger = evaluateCondition(
            questionValue,
            parsedCondition.condition,
            parsedCondition.rightValue,
          );

          if (shouldTrigger) {
            // start

            prepareDataToPopulate(metadata);
            // end
          } else {
            prepareDataToPopulate(metadata, true);
          }
        }
      }
    }
  };

  // meatdata to map or find , value to be mapped or cleared.
  const prepareDataToPopulate = async (
    metadata: any,
    clearValue: Boolean = false,
  ) => {
    dispatch(togglePopupLoader(true));

    dispatch(togglePopupLoader(false));

    const conditions = splitMultipleConditions(metadata.map);

    conditions.forEach(condition => {
      const questionUniqueKey = parseConditionalValue(
        evalCondition(condition).rightValue,
      );

      const valueKey = parseConditionalValue(
        evalCondition(condition).leftValue,
      );

      const updatableQuestion = deepClone(currentQuestions).filter(q => {
        if (
          q.metadata.question_type === 'dropdown' &&
          q.unique_key === questionUniqueKey
        ) {
          return q;
        } else {
          const filteredChoices = q.choices.filter(
            c => c.unique_key === questionUniqueKey,
          );

          if (filteredChoices.length) {
            q.choices = filteredChoices;

            return q;
          } else {
            return false;
          }
        }
      });

      try {
        // eslint-disable-next-line no-eval
        const value = !clearValue
          ? valueKey === 'Self'
            ? valueKey
            : get('details', valueKey)
          : null;

        populateData(updatableQuestion, value);
      } catch (e) {
        Logger.log(e);
      }
    });
  };

  const populateData = (updatableQuestion: Any, value: any) => {
    if (
      updatableQuestion &&
      updatableQuestion[0]?.id &&
      updatableQuestion[0]?.choices[0]?.id
    ) {
      if (updatableQuestion[0]?.metadata?.question_type === 'dropdown') {
        const updatedChoices = updatableQuestion[0]?.choices.map(c => {
          if (c.title === value) {
            c.selected = true;
            c.value = c.title;
          } else {
            c.selected = false;
            c.value = null;
          }

          return c;
        });

        dispatch(
          updateQuestionValue(updatableQuestion[0].id, null, updatedChoices),
        );
      } else {
        dispatch(
          updateQuestionValue(
            updatableQuestion[0].id,
            updatableQuestion[0].choices[0].id,
            value || null,
          ),
        );
      }
    }
  };

  useEffect(() => {
    if (
      question?.unique_key?.toLowerCase().includes('firstname') &&
      !question?.unique_key?.toLowerCase()?.includes('additionalparticipant') &&
      !question?.unique_key
        ?.toLowerCase()
        ?.includes('policyHolderFirstNameInsuranceDetails')
    ) {
      dispatch(setUserFullName(choices[0]?.value, 'firstname'));
    }

    if (
      question?.unique_key?.toLowerCase().includes('lastname') &&
      !question?.unique_key?.toLowerCase()?.includes('additionalparticipant') &&
      !question?.unique_key
        ?.toLowerCase()
        ?.includes('policyHolderLastNameInsuranceDetails')
    ) {
      dispatch(setUserFullName(choices[0]?.value, 'lastname'));
    }
  }, [question]);

  const inputOnChange = (value: any, choiceId: string, isValid: boolean) => {
    const currentQuestion = currentQuestions.find(q =>
      q.choices.some(c => c.id === choiceId),
    );

    const questionUniqueKey = currentQuestion?.unique_key?.toLowerCase();
    const isIgnored = ignoredUniqueKeys.some(key =>
      questionUniqueKey?.includes(key),
    );

    dispatch(
      updateQuestionValue(currentQuestion?.id, choiceId, value, isValid),
    );

    if (questionUniqueKey?.includes('firstname') && !isIgnored) {
      dispatch(setUserFullName(value, 'firstname'));
    }

    if (questionUniqueKey?.includes('lastname') && !isIgnored) {
      dispatch(setUserFullName(value, 'lastname'));
    }

    if (userToBeOnboarded && Object.entries(userToBeOnboarded).length > 0) {
      if (questionUniqueKey?.includes('firstname') && !isIgnored) {
        const fullName =
          value +
          (userToBeOnboarded?.last_name?.trim()
            ? ' ' + userToBeOnboarded?.last_name
            : '');

        dispatch(
          setUserToBeOnboarded({
            ...userToBeOnboarded,
            first_name: value,
            full_name: fullName,
          }),
        );
      }

      if (questionUniqueKey?.includes('lastname') && !isIgnored) {
        dispatch(
          setUserToBeOnboarded({
            ...userToBeOnboarded,
            last_name: value,
            full_name: (userToBeOnboarded?.first_name || '') + ' ' + value,
          }),
        );
      }
    }
  };

  const textAreaOnChange = (
    value: any,
    choiceId: string,
    isRequired: boolean,
  ) => {
    const isValid = isRequired ? !!value.length : true;

    dispatch(updateQuestionValue(question.id, choiceId, value, isValid));
  };

  const onLocationSelection = (value: object, choiceId: string) => {
    const isValid = !!value;
    const valueInString = value ? JSON.stringify(value) : '';

    dispatch(
      updateQuestionValue(question.id, choiceId, valueInString, isValid),
    );
  };

  const onZipCodeLocationSelection = (
    selectedOption: any,
    choiceId: string,
  ) => {
    const zip =
      selectedOption?.zipCode != null
        ? String(selectedOption.zipCode).padStart(5, '0')
        : '';

    dispatch(updateQuestionValue(question.id, choiceId, zip, true));
  };

  const onZipCodeSearchLifecycleChange = (choiceId: string, state: any) => {
    dispatch(
      updateQuestionValue(question.id, choiceId, state.rawValue, state.isValid),
    );
  };

  const dateOnChange = (value: string, choiceId: string) => {
    dispatch(
      updateQuestionValue(
        question.id,
        choiceId,
        value,
        !(value === '' || value == null),
      ),
    );
  };

  const dropdownOnSelected = (value: array) => {
    if (question.unique_key === 'patientRelationshipInsuranceDetailsQuestion') {
      filterAndDispatch(
        currentQuestions,
        [
          'policyHolderFirstNameInsuranceDetailsQuestion',
          'policyHolderLastNameInsuranceDetailsQuestion',
          'policyHolderDateOfBirthInsuranceDetailsQuestion',
        ],
        dispatch,
      );
    }

    if (
      question.unique_key ===
        QuestionsUniqueKeys.patientsAgeSelfMatchingClientQuestionV1 &&
      value
    ) {
      const selectedValue = value.filter(filter => filter.selected);

      if (selectedValue && selectedValue.length) {
        const ageRangeValue = selectedValue[0].raw_metadata;

        localStorage.setItem('age_range', ageRangeValue || '');
      }
    }

    dispatch(updateQuestionValue(question.id, null, value));
  };

  const onSliderValueChange = (value: number, choiceId: string) => {
    dispatch(updateQuestionValue(question.id, choiceId, value));
    scrollIntoNextQuestion();
  };

  const multipleSelectionChanges = (choiceId: string, value: any) => {
    dispatch(updateQuestionValue(question.id, choiceId, value));
  };

  const [noUseOfInsurance, setNoUseOfInsurance] = useState(false);

  const onChangeRadioValue = (value: array) => {
    if (
      value.filter(choice => choice.selected === true && choice.modal_message)
        .length > 0
    ) {
      dispatch(
        setModalContent({
          modalContent: (
            <div className="p-2">
              <Typography
                variant="size-20"
                color="color-2"
                className="m-3 mt-0"
              >
                {sanitiseHTML(
                  value.filter(
                    choice => choice.selected === true && choice.modal_message,
                  )[0].modal_message,
                )}
              </Typography>
            </div>
          ),
          title: 'Are you sure?',
          isDisableClose: true,
          isWithCloseButton: false,
          confirmButtonLabel: 'I Understand',
          isGeneralPopup: true,
          onConfirmButtonClick: () => dispatch(clearModalContent()),
          size: 'lg',
          className: 'understand-modal',
        }),
      );
    }

    // ToDo : MAKE THIS CODE DYNAMIC. IDEALLY IT SHOULD BE DYNAMIC AFTER DISCUSSION WITH BE TEAM ADDED HARDCODED FOR BE CONVENIENCE ADDED AT LINE 782.FYI
    if (
      value.filter(
        choice =>
          (choice.unique_key === 'yesWantInsuranceSelfMatchingClientChoiceV1' ||
            choice.unique_key ===
              'noWantInsuranceSelfMatchingClientChoiceV1') &&
          choice.selected === true,
      ).length > 0
    ) {
      value.filter(
        choice =>
          choice.unique_key === 'noWantInsuranceSelfMatchingClientChoiceV1' &&
          choice.selected === true,
      ).length > 0
        ? setNoUseOfInsurance(true)
        : setNoUseOfInsurance(false);
    }

    dispatch(updateQuestionValue(question.id, null, value));
    poulateFromSource(value);
  };

  const onImageUploaded = (imagebase64: string, choiceId: string) => {
    dispatch(updateQuestionValue(question.id, choiceId, imagebase64));
  };

  const onDocumentUploaded = (docId: string, choiceId: string) => {
    dispatch(updateQuestionValue(question.id, choiceId, docId));
  };

  const onSignature = (docId: string, choiceId: string, data: any) => {
    dispatch(updateQuestionValue(question.id, choiceId, docId));
    dispatch(updateChoiceMetadata(question.id, choiceId, data));
    dispatch(clearModalContent());
  };

  const onToken = (
    status: AddCardStatus.ERROR | AddCardStatus.SUCCESS,
    choice,
  ) => {
    dispatch(updateQuestionValue(question.id, choice.id, status));
  };

  // slowly scroll into next question for slider
  const scrollIntoNextQuestion = () => {
    const nextQuestion = findNextQuestion(question, currentQuestions);
    const nextQuestionId = nextQuestion.id;
    const el =
      document.getElementById(nextQuestionId) ||
      document.querySelectorAll('.question-container')[0];

    if (el && !el.classList.contains('rendered')) {
      el.scrollIntoView({ block: 'start', behavior: 'smooth' });
      el.classList.add('rendered');
    }
  };

  const handleDocType = () => {
    if (
      documentType === DocumentType.PROFILE_PIC ||
      documentType === DocumentType.OFFICE_PIC
    ) {
      return (
        <PhotoInformationContainer
          setUploading={setUploading}
          questionData={question}
          onChange={onImageUploaded}
          userDetails={userToBeOnboarded}
          isIntakeQuestionnaire={true}
          documentType={documentType}
        />
      );
    } else if (documentType?.includes(DocumentType.THERAPIST_CONSENT)) {
      return (
        <DocumentUpload
          userDetails={userToBeOnboarded}
          questionData={question}
          onChange={onDocumentUploaded}
          supportData={supportData}
          fileMaxSize={fileMaxSize}
          documentType={documentType}
          handleOnclick={handleOnclick}
        />
      );
    } else {
      return null;
    }
  };

  const options = () => {
    switch (type) {
      case 'text':
        return (
          <>
            <Box sx={{ width: '100%', margin: 'auto' }}>
              <Grid
                container={true}
                rowSpacing={1}
                spacing={4}
                sx={{
                  maxWidth: '100%',
                  margin: 'auto',
                  width: isFromMobile ? '100%' : '920px',
                  padding: isFromMobile ? 'auto' : 'auto',
                }}
              >
                {choices &&
                  choices.map(choice => {
                    const renderCurrentChoice = shouldRenderChoice(
                      choice,
                      choices,
                    );

                    return (
                      renderCurrentChoice && (
                        <Grid
                          item={true}
                          sm={
                            choice?.metadata?.choice_layout === 'grid' ? 6 : 12
                          }
                          justifyContent={
                            choice?.metadata?.choice_layout === 'grid'
                              ? 'flex-start'
                              : 'center'
                          }
                          className={`${
                            choice?.metadata?.choice_layout === 'grid'
                              ? !question?.title &&
                                question?.metadata?.hide_question_title ===
                                  'true'
                                ? `margin-none`
                                : 'grid-choice'
                              : 'no-grid-choice'
                          } ${choice.unique_key}`}
                        >
                          {isDirectoryPlatform &&
                          question?.unique_key ===
                            QuestionsUniqueKeys.inPersonOfficeZipCodeQuestion ? (
                            <TypeAheadLocationSearch
                              choices={[choice]}
                              type="questionnaire"
                              title={choice.title}
                              infoMessage={choice.info_message || infoMessage}
                              displayField="zipCode"
                              restrictInputToDigits={true}
                              searchTriggerLength={
                                choice?.metadata?.validation_char_length || 5
                              }
                              emptyResultsMessage="Enter a valid zip code"
                              selectionRequiredMessage="Enter a valid zip code"
                              searchingStatusText="Checking zip code..."
                              blockedLocationMessage="Please enter the physical street address of your clinical office. PO Boxes, tax mailing addresses, and government administrative ZIPs cannot be listed as practice locations."
                              onLocationSelection={onZipCodeLocationSelection}
                              blockInvalidOfficeLocations={true}
                              isValid={!!choice.value}
                              onSearchLifecycleChange={state =>
                                onZipCodeSearchLifecycleChange(choice.id, state)
                              }
                            />
                          ) : (
                            <InputContainer
                              variant=""
                              infoMessage={choice.info_message || infoMessage}
                              title={choice.title}
                              placeholder={choice.place_holder}
                              onChange={(value: any, isValid: boolean) =>
                                inputOnChange(value, choice.id, isValid)
                              }
                              value={choice.value}
                              className=""
                              isRequired={
                                choice?.required !== undefined
                                  ? isRequired && choice?.required
                                  : isRequired
                              }
                              type={type}
                              metadata={choice.metadata}
                              uniqueKey={choice.unique_key}
                              pageUniqueKey={currentPage?.unique_key}
                            />
                          )}
                        </Grid>
                      )
                    );
                  })}
              </Grid>
            </Box>
          </>
        );
      case 'textarea':
        return (
          <>
            {choices &&
              choices.map(choice => (
                <>
                  <TextArea
                    // label='This is static label'
                    variant=""
                    info={infoMessage}
                    title={choice.title}
                    placeholder={choice.place_holder}
                    onChange={(value: any) =>
                      textAreaOnChange(
                        value,
                        choice.id,
                        choice?.required !== undefined
                          ? isRequired && choice?.required
                          : isRequired,
                      )
                    }
                    value={choice.value}
                    className={
                      choice.unique_key ===
                      'scheduleAvailabilityNewClientQuestionChoiceV1'
                        ? 'mb-4'
                        : ''
                    }
                    isRequired={
                      choice?.required !== undefined
                        ? isRequired && choice?.required
                        : isRequired
                    }
                    metadata={question?.metadata}
                    type={type}
                  />
                </>
              ))}
          </>
        );
      case 'checkbox':
        return (
          <>
            {
              <>
                <CheckBoxContainer
                  className="mt-4"
                  metadata={metaData}
                  choices={choices}
                  question={question}
                  onChange={multipleSelectionChanges}
                />
              </>
            }
          </>
        );
      case 'nodecheckbox':
        return (
          <>
            {
              <>
                <NodeCheckBoxContainer
                  className="mt-4"
                  onChange={multipleSelectionChanges}
                  choices={choices}
                />
              </>
            }
          </>
        );
      case 'cardcheckbox':
        return (
          <>
            {
              <>
                <CardComponentContainer
                  className="mt-4"
                  onChange={multipleSelectionChanges}
                  questionMetaData={question}
                  choices={choices}
                />
              </>
            }
          </>
        );
      case 'cardradiobox':
        return (
          <>
            {
              <>
                <RadioCardComponentContainer
                  className="mt-6"
                  onChange={updatedChoices =>
                    onChangeRadioValue(updatedChoices)
                  }
                  choices={choices}
                  questionMetaData={question}
                />
              </>
            }
          </>
        );
      case 'radio':
        return (
          <>
            {
              <>
                <RadioBoxContainer
                  className="mt-4"
                  onChange={updatedChoices =>
                    onChangeRadioValue(updatedChoices)
                  }
                  choices={choices}
                />
              </>
            }
          </>
        );
      case 'dropdown':
        return (
          <>
            {
              <>
                <DropdownContainer
                  className=""
                  title={question.display_title}
                  onChangeValue={dropdownOnSelected}
                  infoMessage={infoMessage}
                  menu={choices}
                  fromQuestionnaire={true}
                />
              </>
            }
          </>
        );
      case 'date':
        return (
          <>
            {choices &&
              choices.map(choice => (
                <>
                  <DatePicker
                    placeholder={choice.place_holder}
                    infoMessage={infoMessage}
                    title={choice.title}
                    onChange={(value: string) => dateOnChange(value, choice.id)}
                    inputValue={choice.value}
                    question={question}
                    choice={choice}
                  />
                </>
              ))}
          </>
        );
      case 'year':
        return (
          <>
            {choices &&
              choices.map(choice => (
                <>
                  <DatePicker
                    placeholder={choice.place_holder}
                    infoMessage={infoMessage}
                    title={choice.title}
                    onChange={(value: string) => dateOnChange(value, choice.id)}
                    inputValue={choice.value}
                    onlyYear={true}
                    currentQuestions={currentQuestions}
                    validateQuestion={
                      choice?.metadata?.date_should_greater_than
                    }
                    question={question}
                  />
                </>
              ))}
          </>
        );
      case 'file':
        return (
          <div className="mt-3 file-component-parent">{handleDocType()}</div>
        );
      case 'customslider':
        return (
          <div className="mt-3 file-component-parent">
            {choices.map(choice => {
              return (
                <div className="mt-0 mb-3">
                  <RangePicker
                    onValueChange={value => {
                      onSliderValueChange(value, choice.id);
                    }}
                    exquestiondata={choice}
                  />
                </div>
              );
            })}
          </div>
        );
      case 'zipcode':
        return (
          <>
            <ZipCodeContainer question={question} />
          </>
        );
      case 'intakeCompletionWelcomeScreen':
        return (
          <>
            <IntakeCompletionWelcomeContainer />
          </>
        );

      case QuestionType.I2IChargesScreen:
        return (
          <>
            <PaymentExplanationPage
              choices={choices}
              onToken={(status, choice) => {
                dispatch(updateQuestionValue(question.id, choice.id, status));
              }}
              metaData={metaData}
            />
          </>
        );
      case 'document_upload':
        return (
          <div className="upload-insurance-container">
            {choices &&
              choices.map(choice => (
                <UploadDocument
                  // className={'mx-5'}
                  choice={choice}
                  page={currentPage}
                  question={question}
                  placeholder={choice.place_holder}
                  description={choice.description}
                  questionData={question}
                  onChange={onImageUploaded}
                  onClick={noop}
                  isFileTypeInvalid={isFileTypeInvalid}
                  setIsFileTypeInvalid={setIsFileTypeInvalid}
                />
              ))}
          </div>
        );
      case 'esign':
        return (
          <>
            {choices &&
              choices.map(choice => (
                <div key={choice?.id}>
                  <SignPad
                    choice={choice}
                    onSignature={(docId: string, data: any) =>
                      onSignature(docId, choice.id, data)
                    }
                  />
                </div>
              ))}
          </>
        );
      case 'esign_custom_consent':
        return (
          <>
            {choices &&
              choices.map(choice => (
                <div key={choice?.id}>
                  <ConsentForm
                    choice={choice}
                    onSignature={(docId: string, data: any) =>
                      onSignature(docId, choice.id, data)
                    }
                    handleOnclick={handleOnclick}
                  />
                </div>
              ))}
          </>
        );
      case 'credit_card_capture':
        return (
          <>
            {choices &&
              choices.map(choice => (
                <Payment choice={choice} onToken={onToken} />
              ))}
          </>
        );
      case 'clinician_availability':
        return (
          <>
            <ClinicianAvailabilityQuestion
              choices={choices}
              userId={selfUserId}
              handleOnclick={handleOnclick}
              setIsMatchAssistance={setIsMatchAssistance}
            />
          </>
        );
      case 'location_search':
        return (
          <TypeAheadLocationSearch
            choices={choices}
            onLocationSelection={onLocationSelection}
            type="questionnaire"
          />
        );
      case 'stripe_credit_card_capture':
        return (
          <StripePayment
            ref={stripePaymentRef}
            choices={choices}
            onToken={(status, choice) => {
              dispatch(updateQuestionValue(question.id, choice.id, status));
            }}
            fromOnboarding={true}
            onCardStatusChange={onStripeCardStatusChange}
            onCardFormValidationChange={onStripeCardFormValidationChange}
            onStripeProcessingChange={onStripeProcessingChange}
          />
        );
      case 'standalone-checkbox':
        return (
          <>
            {choices &&
              choices.map(choice => (
                <div key={choice?.id}>
                  <MiniCheckBox
                    id={choice.id}
                    text={choice.title || choice.value}
                    selected={choice.selected || false}
                    isActive={choice.selected}
                    isCheckFirst={choice.selected || false}
                    onClick={(newSelected, id) => {
                      const updatedChoices = (choices || []).map(c => {
                        if (c.id === id) {
                          return {
                            ...c,
                            selected: newSelected,
                            value: newSelected ? c.value : null,
                          };
                        }

                        return c;
                      });

                      onChangeRadioValue(updatedChoices);
                    }}
                    inputValue={choice.value || ''}
                    className={
                      choice?.metadata?.className ||
                      'standalone-checkbox-wrapper ms-4'
                    }
                  />
                </div>
              ))}
          </>
        );
      case QuestionType.I2IProviderOnboardingExplanationScreen:
        return (
          <>
            <ProviderBenefitPage />
          </>
        );
      case QuestionType.PracticeSummaryInformationScreen:
        return (
          <>
            <PracticeSummaryInfoPage />
          </>
        );
      case QuestionType.Password:
        return (
          <>
            <PasswordScreenClientQuestionnaire handleOnclick={handleOnclick} />
          </>
        );
      default:
        break;
    }
  };

  return (
    <div className="options-parent">
      {options()}
      {noUseOfInsurance && (
        <div className="d-flex justify-content-center">
          <Typography
            variant="size-16"
            color="color-2"
            className="mt-5 mb-5"
            style={{ width: '100%', textAlign: 'center', maxWidth: '496px' }}
          >
            You have the right to a good faith estimate for your services which
            may be obtained at any time by contacting our scheduling team.
          </Typography>
        </div>
      )}
    </div>
  );
}

// const Questionnaire: any = withLoading<React$Element<Props>>(QuestionPage);

export default QuestionOptionsLibrary;
